import React, { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import axios from "axios";
import _debounce from "lodash.debounce";
import ReactPlayer from "react-player/lazy";
import { Carousel } from "react-responsive-carousel";
import { SlideshowLightbox } from "lightbox.js-react";
import { useDispatch, useSelector } from "react-redux";

import { BASE_URL } from "../../Utils/BaseUrl";
import { getCount } from "../../../Store/CountActions";

import img from "../../../images/userimg.jpg";
import loader from "../../../images/loader.gif";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "react-responsive-carousel/lib/styles/carousel.min.css";
import { createPortal } from "react-dom";
const ProfileDetailCard = () => {

    const { userid } = useParams();
    const dispatch = useDispatch();

    const [posts, setPosts] = useState([]);
    const [likedata, setLikedata] = useState([]);
    const [profile, setProfile] = useState({});
    const [likecount, setLikecount] = useState([]);
    const [userlike, setUserlike] = useState([]);
    const [commentshow, setCommentShow] = useState({});
    const [loading, setLoading] = useState(true);

    const count = useSelector((state) => state.Count.count);
    const currentPostId = useSelector((state) => state.Count.postId);

    const deleteuserid = localStorage.getItem("user_id");

    const [value, setValue] = useState({ comment: "" });

    const [openMenu, setOpenMenu] = useState(null);
    const [editMode, setEditMode] = useState(false);
    const [editPost, setEditPost] = useState(null);
    const [updating, setUpdating] = useState(false);

    const formatDate = (date) => {
        const d = new Date(date);
        let dd = d.getDate().toString().padStart(2, '0');
        let mm = (d.getMonth() + 1).toString().padStart(2, '0');
        let yy = d.getFullYear().toString().slice(-2);
        return `${dd}-${mm}-${yy}`;
    };

    const renderClickableText = (text) => {
        if (!text) return "";

        const words = text.split('#');

        return words.map((word, i) => (
            word ?
                <Link key={i} to={`/postlistingpage/${word}`} className="post-hash">
                    #{word}
                </Link>
                : null
        ));
    };

    const handleEdit = (post) => {
        setEditPost({
            ...post,
            description: post.description || post.discription || ""
        });
        setEditMode(true);
        setOpenMenu(null);
    };

    const getProfile = async () => {
        try {

            const res = await axios.post(`${BASE_URL}/user_detail_get`, {
                user_id: userid
            });

            setProfile(res.data);

        } catch (err) {
            console.log(err);
        }
    };

    // ---------------- POSTS ----------------

    const getPosts = async () => {
        try {

            const res = await axios.post(`${BASE_URL}/posts`, {
                user_id: userid
            });

            // setPosts(res.data);

            setPosts([...res.data]);
            setLoading(false);

        } catch (err) {
            console.log(err);
        }
    };

    const closeModal = () => {
        setEditMode(false);
        setEditPost(null);
    };

    const toggleMenu = (id) => {
        setOpenMenu(openMenu === id ? null : id);
    };

    const deletePost = async (post_id) => {
        const confirmDelete = window.confirm("Are you sure?");
        if (!confirmDelete) return;

        try {
            // instant UI remove
            setPosts(prev => prev.filter(p => p.post_id !== post_id));

            await axios.post(`${BASE_URL}/delete_post`, {
                post_id,
                user_id: localStorage.getItem("user_id")
            });

            toast.success("Post deleted successfully 🗑️");
            window.location.reload();
            // background refresh
            getPosts();
            getLikeCount();

        } catch (err) {
            console.log(err);
            toast.error("Delete failed ❌");

            // rollback
            getPosts();
        }
    };
    // ---------------- LIKE DATA ----------------

    const getLikeData = async () => {
        try {

            const res = await axios.post(`${BASE_URL}/post_like_data`, {
                user_id: userid
            });

            setLikedata(res.data);

        } catch (err) { console.log(err); }
    };


    // ---------------- LIKE COUNT ----------------

    const getLikeCount = async () => {
        try {

            const res = await axios.post(`${BASE_URL}/dash_post_count`, {
                user_id: userid
            });

            setLikecount(res.data);

        } catch (err) { console.log(err); }
    };


    // ---------------- LIKE POST ----------------

    const handleLike = _debounce((id) => {

        axios.post(`${BASE_URL}/dash_post_like`, {
            post_id: id,
            user_id: userid
        }).then(() => {
            getLikeData();
            getLikeCount();
        });

    }, 200);


    // ---------------- LIKE USER LIST ----------------

    const getLikeUsers = async (id) => {

        const res = await axios.post(`${BASE_URL}/post_like_user`, {
            post_id: id
        });

        setUserlike(res.data);

    };


    // ---------------- COMMENT TOGGLE ----------------

    const toggleComment = (index) => {

        setCommentShow(prev => ({
            ...prev,
            [index]: !prev[index]
        }));

    };


    // ---------------- COMMENT INPUT ----------------

    const handleChange = (e) => {
        setValue(prev => ({ ...prev, [e.target.name]: e.target.value }));
    };


    // ---------------- LOAD DATA ----------------

    useEffect(() => {
        getProfile();
        getPosts();
        getLikeData();
        getLikeCount();
    }, [userid]);

    const handleUpdate = async (e) => {
        e.preventDefault();

        try {
            setUpdating(true);

            await axios.post(`${BASE_URL}/update_post`, {
                post_id: editPost.post_id,
                user_id: localStorage.getItem("user_id"),
                title: editPost.title,
                discription: editPost.description
            });

            // ✅ Update UI instantly
            setPosts((prev) =>
                prev.map((p) =>
                    p.post_id === editPost.post_id
                        ? { ...p, title: editPost.title, description: editPost.description }
                        : p
                )
            );

            // ✅ Toast success
            toast.success("Post updated successfully ✅");

            // ✅ Close modal
            closeModal();

        } catch (err) {
            console.log(err);
            toast.error("Update failed ❌");
        } finally {
            setUpdating(false);
        }
    };

    return (

        <>
            {/* <div className="card shadow-sm mb-4">

                <div className="card-body">

                    <div className="d-flex align-items-center flex-wrap gap-3">

                        <div style={{ width: 80, height: 80 }}>

                            {profile?.profile_image?.trim() ? (

                                <SlideshowLightbox iconColor="#000" backgroundColor="#fff">

                                    <img
                                        src={`https://thetalentclub.co.in/upload/profile/${profile.profile_image}`}
                                        alt="profile"
                                        className="rounded-circle w-100 h-100"
                                        style={{ objectFit: "cover" }}
                                        onError={(e) => {
                                            e.target.onerror = null;
                                            e.target.style.display = "none";
                                            e.target.parentElement.nextSibling.style.display = "flex";
                                        }}
                                    />

                                </SlideshowLightbox>

                            ) : null}

                            <div
                                className="rounded-circle bg-primary text-white d-flex align-items-center justify-content-center fw-bold"
                                style={{
                                    width: "80px",
                                    height: "80px",
                                    fontSize: "26px",
                                    display: profile?.profile_image?.trim() ? "none" : "flex"
                                }}
                            >
                                {(
                                    (profile?.firstname?.charAt(0) || "") +
                                    (profile?.lastname?.charAt(0) || "")
                                ) || "U"}
                            </div>

                        </div>


                        <div className="flex-grow-1">

                            <h5 className="mb-1 fw-semibold">
                                {profile?.firstname} {profile?.lastname}
                            </h5>

                            <p className="text-muted small mb-2">
                                {profile?.bio || "No bio available"}
                            </p>


                            <div className="d-flex gap-4">

                                <div className="text-center">
                                    <div className="fw-bold">{posts.length}</div>
                                    <small className="text-muted">Posts</small>
                                </div>

                                <div className="text-center">
                                    <div className="fw-bold">{profile?.followers || 0}</div>
                                    <small className="text-muted">Followers</small>
                                </div>

                                <div className="text-center">
                                    <div className="fw-bold">{profile?.following || 0}</div>
                                    <small className="text-muted">Following</small>
                                </div>

                            </div>

                        </div>

                    </div>

                </div>

            </div> */}

            <div className="profile-post-wrapper">

                {loading &&

                    <div className="text-center p-4">
                        <img src={loader} width="60" alt="loading" />
                    </div>

                }


                {posts?.map((item, index) => {

                    const likeData = likecount?.find(l => l.post_id === item.post_id);
                    const isLiked = likedata?.some(l => l.post_id === item.post_id);

                    return (

                        <div className="post-card" key={index}>


                            {/* POST HEADER */}

                            <div className="post-header suggestion-usd d-flex align-items-center justify-content-between mb-2">

                                <div className="d-flex align-items-center">

                                    <img
                                        className="profile-img"
                                        src={item.profile_image ? `https://thetalentclub.co.in/upload/profile/${item.profile_image}` : img}
                                    />

                                    <div className="ms-2">

                                        <h5 className="mb-0">
                                            {item.firstname} {item.lastname}
                                        </h5>

                                        <small className="text-muted">
                                            {formatDate(item.createdDate)}
                                        </small>

                                    </div>

                                </div>

                                <div style={{ position: "relative" }}>

                                    <i
                                        className="bi bi-three-dots-vertical"
                                        style={{ cursor: "pointer", fontSize: 20 }}
                                        onClick={() => toggleMenu(item.post_id)}
                                    ></i>

                                    {openMenu === item.post_id && (

                                        <div
                                            className="dropdown-menu show shadow border-0"
                                            style={{ right: 0, left: "auto" }}
                                        >

                                            <button
                                                className="dropdown-item d-flex align-items-center gap-2"
                                                onClick={() => handleEdit(item)}
                                            >
                                                Edit
                                            </button>

                                            <button
                                                className="dropdown-item text-danger d-flex align-items-center gap-2"
                                                onClick={() => deletePost(item.post_id)}
                                            >
                                                Remove
                                            </button>

                                        </div>
                                    )}

                                </div>
                            </div>



                            {/* MEDIA */}

                            {item.post_images?.length > 0 &&

                                <Carousel showThumbs={false} infiniteLoop>

                                    {item.post_images.map((media, i) => {

                                        return (

                                            <div key={i}>

                                                {media.endsWith(".mp4") ?

                                                    <ReactPlayer
                                                        url={`https://thetalentclub.co.in/upload/post_files/${media}`}
                                                        controls
                                                        width="100%"
                                                    />

                                                    :

                                                    <SlideshowLightbox>

                                                        <img
                                                            src={`https://thetalentclub.co.in/upload/post_files/${media}`}
                                                            alt=""
                                                        />

                                                    </SlideshowLightbox>

                                                }

                                            </div>

                                        );

                                    })}

                                </Carousel>

                            }



                            {/* POST CONTENT */}

                            <div className="post-content">

                                <p className="post-title" style={{ color: "black" }}>
                                    {item.title}
                                </p>

                                {item.description?.includes('#')
                                    ? renderClickableText(item.description)
                                    : <p>{item.description}</p>
                                }

                            </div>



                            {/* ACTIONS */}

                            <div className="post-actions">

                                <button
                                    className={isLiked ? "like-btn active" : "like-btn"}
                                    onClick={() => handleLike(item.post_id)}
                                >
                                    ❤️
                                </button>

                                <span
                                    onClick={() => getLikeUsers(item.post_id)}
                                    className="like-count"
                                >
                                    {likeData?.like_count || 0} Likes
                                </span>


                                <button
                                    className="comment-btn"
                                    onClick={() => {
                                        toggleComment(index);
                                        dispatch(getCount(item.post_id));
                                    }}
                                >
                                    💬
                                </button>

                                <span>
                                    {likeData?.comment_count || 0} Comments
                                </span>

                            </div>



                            {/* COMMENTS */}

                            {commentshow[index] &&

                                <div className="comment-section">

                                    {count?.map((c, i) => (

                                        <div className="comment-row" key={i}>

                                            <img
                                                className="comment-avatar"
                                                src={c.profile_image ? `https://thetalentclub.co.in/upload/profile/${c.profile_image}` : img}
                                            />

                                            <div className="comment-box">

                                                <strong>
                                                    {c.firstname} {c.lastname}
                                                </strong>

                                                <p>{c.comment}</p>

                                                {deleteuserid == c.user_id &&

                                                    <span
                                                        className="delete-comment"
                                                        onClick={() => {

                                                            axios.post(`${BASE_URL}/delete_user_comment`, {
                                                                comment_id: c.id
                                                            })
                                                                .then(() => {
                                                                    dispatch(getCount(currentPostId));
                                                                    getLikeCount();
                                                                });

                                                        }}
                                                    >
                                                        Delete
                                                    </span>

                                                }

                                            </div>

                                        </div>

                                    ))}


                                    {/* COMMENT INPUT */}

                                    <div className="comment-input">

                                        <input
                                            type="text"
                                            name="comment"
                                            placeholder="Write comment..."
                                            value={value.comment}
                                            onChange={handleChange}
                                        />

                                        <button
                                            onClick={() => {

                                                if (value.comment === "") return;

                                                axios.post(`${BASE_URL}/add_comment`, {

                                                    user_id: localStorage.getItem("user_id"),
                                                    post_id: currentPostId,
                                                    comment: value.comment

                                                }).then(() => {

                                                    dispatch(getCount(currentPostId));
                                                    getLikeCount();

                                                });

                                                setValue({ comment: "" });

                                            }}
                                        >
                                            Send
                                        </button>

                                    </div>

                                </div>

                            }

                        </div>


                    );

                })}



                {posts.length === 0 &&

                    <div className="text-center p-5">

                        <h4>No Posts Available</h4>

                    </div>

                }
                <ToastContainer position="top-right" autoClose={3000} />
            </div>

            {editMode &&
                createPortal(

                    <div
                        className="modal fade show d-block"
                        tabIndex="-1"
                        style={{
                            position: "fixed",
                            top: "15%",
                            left: "10%",
                            width: "100%",
                            height: "100%",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            zIndex: 9999
                        }}
                    >

                        <div className="modal-dialog modal-lg w-100" style={{ maxWidth: "700px" }}>
                            <div className="modal-content border-0 shadow rounded-4">

                                {/* HEADER */}
                                <div className="modal-header border-0">
                                    <h5 className="modal-title fw-bold">Edit Post</h5>
                                    <button className="btn-close" onClick={closeModal}></button>
                                </div>

                                <form onSubmit={handleUpdate}>

                                    {/* BODY */}
                                    <div className="modal-body">

                                        <div className="mb-3">
                                            <label className="form-label fw-semibold">Title</label>
                                            <input
                                                type="text"
                                                className="form-control"
                                                value={editPost?.title || ""}
                                                onChange={(e) =>
                                                    setEditPost({ ...editPost, title: e.target.value })
                                                }
                                            />
                                        </div>

                                        <div className="mb-2">
                                            <label className="form-label fw-semibold">Description</label>
                                            <textarea
                                                className="form-control"
                                                rows="4"
                                                value={editPost?.description || ""}
                                                onChange={(e) =>
                                                    setEditPost({ ...editPost, description: e.target.value })
                                                }
                                            />
                                        </div>

                                    </div>

                                    {/* FOOTER */}
                                    <div className="modal-footer border-0">
                                        <button type="button" className="btn btn-light" onClick={closeModal}>
                                            Cancel
                                        </button>

                                        <button type="submit" className="btn btn-light" disabled={updating}>
                                            {updating ? "Saving..." : "Submit"}
                                        </button>
                                    </div>

                                </form>

                            </div>
                        </div>

                        {/* BACKDROP */}
                        <div
                            style={{
                                position: "fixed",
                                top: 0,
                                left: 0,
                                width: "100%",
                                height: "100%",
                                background: "rgba(0,0,0,0.2)",
                                zIndex: -1
                            }}
                        />

                    </div>,

                    document.body
                )
            }
        </>
    );

};

export default ProfileDetailCard;